import { Classes, H6 } from "@blueprintjs/core";
import { Input } from "decorator-form";
import React from "react";
import { Entity, Field } from "typegraph";

import CountResult from "common/entities/CountResult";
import { ID } from "common/entities/IEntity";
import { IFileUpload } from "common/form/fields/upload/UploadField";
import InputType from "common/form/InputType";
import { IPageableListQuery } from "common/models/IPageableListQuery";
import { EntityTable } from "core/components/EntityTable";
import entityMeta from "../entityMeta";


export class File {

	@Field()
	public id: ID;

	@Field()
	public displayName: string;

	@Field()
	public description: string;

	@Field()
	public name: string;

	@Field()
	public url: string;

	@Field()
	public contentType: string;

}

@Entity(entityMeta.ATTACHMENT)
export class Attachment {

	@Field()
	public id: ID;

	@Field()
	public fileUrl: string;

	@Input({
		type: InputType.UPLOAD,
		title: "File",
		required: true
	})
	public tempUpload?: IFileUpload;

	@Field({entity: File})
	public file: File;

	@Input({type: InputType.TEXT, title: "Name", required: true})
	public fileDisplayName?: string;

	@Input({type: InputType.TEXT_HTML, title: "Description"})
	public fileDescription?: string;

}

function mapQueryParams(args: any) {

	const params = {};

	Object.entries(args).forEach(([key, value]) => {

		if (value) {
			params[key] = value;
		}
	});

	return { params };
}

class AttachmentQuery implements IPageableListQuery<Attachment> {

	@Field({
		entity: Attachment,
		aliasFor: "kbAttachment_many",
		params: mapQueryParams
	})
	public entities: null | Attachment[];

	@Field({
		entity: CountResult,
		aliasFor: "kbAttachment_count",
		params: mapQueryParams
	})
	public count: CountResult;

}

interface IAttachmentListProps {
	articleId: ID;
}

export default function AttachmentList(props: IAttachmentListProps) {

	const params = {};

	if (props.articleId) {
		params['articleId'] = props.articleId;
	} else {
		return null;
	}

	return (
		<EntityTable
			pagingQuery={AttachmentQuery}
			formClass={Attachment}
			params={params}
			columns={[
				{
					key: 'name',
					renderCell: ({data}) => {

						return (
							<div>
								<H6>{data.file.displayName}</H6>
								<div
									className={Classes.TEXT_MUTED}
									dangerouslySetInnerHTML={{__html: data.file.description}}
								/>
							</div>
						);
					}
				}
			]}
			onAfterRefetch={
				(data) => {
					const o = {...data};

					if (o.file) {
						o.tempUpload = {
							url: o.file.url,
							name: o.file.name || "",
							type: o.file.contentType
						};

						o.fileDisplayName = o.file.displayName || "";
						o.fileDescription = o.file.description || "";
					}

					return o;
				}
			}
			onBeforeSave={
				(o) => {
					const actionParams = {};

					if (o.id) {
						actionParams['id'] = o.id;
					} else {
						actionParams['articleId'] = props.articleId;
					}

					if (o.tempUpload && (!o.file || o.tempUpload.url !== o.file.url)) {
						actionParams['fileUrl'] = o.tempUpload.url;
						actionParams['fileContentType'] = o.tempUpload.type;
					}

					if (o.fileDisplayName) {
						actionParams['fileDisplayName'] = o.fileDisplayName;
					}

					if (o.fileDescription) {
						actionParams['fileDescription'] = o.fileDescription;
					}

					return actionParams;
				}
			}
		/>
	);
}



// WEBPACK FOOTER //
// ./src/panels/kb/attachment/AttachmentList.tsx